import React, {useState, useEffect} from "react";
import './App.css';

const Schedule = () =>{  
    
        const [scheduleData, setScheduleData] = useState([]);
    
        useEffect(() => {
         fetch("/schedule")
         .then(response => response.json()).then(data => {setScheduleData(data);
        }).catch((error)=>{
            console.error('Error fetching data:', error)
        });
    },[]);
     
     return(
        <div>
            <h1>High Score Challenge Schedule</h1>
            <table className="schedule-table">
                <caption><h3> Friday August 8th - Sunday August 10th</h3></caption>
                <thead>
                    <tr>
                        <th>Day</th>
                        <th>Time</th>
                        <th>Game</th>
                    </tr>
                </thead>
                <tbody>
                {scheduleData?.map((sch) =>
                    (
                    <tr key={sch.id}>
                        <td>{sch.day}</td>
                        <td>{sch.time}</td>
                        <td>{sch.title}</td>
                    </tr>
                    )
                    )}  
                </tbody>
            </table>
        </div>
     );
};

export default Schedule;
